import { createTheme } from '@mui/material/styles';
import { blueGrey } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    chargezoom: {
      main: '#0078ff',
      light: '#3399ff',
      dark: '#0056cc',
      contrastText: '#fff',
    },
  },
  colorSchemes: {
    dark: {
      palette: {
        background: {
          default: '#222',
        },
      },
    },
    light: {
      palette: {
        primary: blueGrey,
        background: {
          paper: '#ecf0f1',
        },
      },
    },
  },
});
